import React, { useEffect } from "react";
import { Output } from "../../Text";
import {
  ContentSection,
  PageWrap,
  SectionHeading,
  Paragraph,
  Button,
} from "@vwfs-bronson/bronson-react";
import { EntryPoint } from "@busdk/storefront-service/dist/models/enums";
import { Icon } from "../Polyfill.jsx";
import { Analytics } from '../../services/analytics';
import { setActualPage, trackInteractionSuccess } from '../../pages/page.utils';

const IdentFailed = (props) => {
  const idNowUrl = props.location?.state?.idNowUrl;

  const pageName = 'Signature failed'

  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
    [Analytics.keys.viewChange()]: pageName,
  }

  const trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.eventType(0)]: 'pageView',
        [Analytics.keys.eventAction(0)]: 'Success',
        [Analytics.keys.eventType(1)]: 'Signature',
        [Analytics.keys.eventAction(1)]: 'Failed',
        [Analytics.keys.eventType(2)]: 'Product journey supplement',
        [Analytics.keys.eventAction(2)]: 'End',
      }
      Analytics.setTrackingData({...defaultTrackingData, ...pageData})
      Analytics.trackPage()
    }, 1000)
  }

  useEffect(() => {
    setActualPage(pageName)
    trackPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ContentSection pale>
        <PageWrap>
          <div
            className={`${
              process.env.REACT_APP_ENTRYPOINT === EntryPoint.HEYCAR
                ? "u-text-center"
                : ""
            }`}
          >
            {process.env.REACT_APP_ENTRYPOINT === EntryPoint.HEYCAR && (
              <Icon icon="semantic-close" size="xxlarge" />
            )}
            <SectionHeading
              level="2"
              center={process.env.REACT_APP_ENTRYPOINT === EntryPoint.HEYCAR}
            >
              {Output.resolve("pages.identFailed.title")}
            </SectionHeading>
            <Paragraph>
              {Output.resolve("pages.identFailed.subtitle")}
            </Paragraph>
            {
              /**
               * Show retry button for HeyCar.
               * (This assumes idNowUrl will always be set for the HeyCar flow.)
               */
              (idNowUrl) &&
              <>
                <Paragraph>
                  {Output.resolve("pages.identFailed.tryAgain")}
                </Paragraph>
                <Paragraph>
                  <Button
                    onClick={() => {
                      window.location.href = idNowUrl;
                      trackInteractionSuccess('Back to Signature', defaultTrackingData)
                    }}
                  >
                    {Output.resolve(
                      "pages.identFailed.retryButtonText"
                    )}
                  </Button>
                </Paragraph>
              </>
            }
            
          </div>
        </PageWrap>
      </ContentSection>
    </>
  );
};

export default IdentFailed;
